const DB = 'mew-wardrobe', STORE = 'xwear'

function database() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB, 1)
    request.onupgradeneeded = () => request.result.createObjectStore(STORE, { keyPath: 'id' })
    request.onsuccess = () => resolve(request.result)
    request.onerror = () => reject(new Error('Could not open the local outfit library'))
  })
}

async function operation(mode, action) {
  const db = await database()
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, mode), request = action(tx.objectStore(STORE))
    tx.oncomplete = () => { db.close(); resolve(request.result) }
    tx.onerror = tx.onabort = () => { db.close(); reject(new Error('Could not save or read the local outfit library')) }
  })
}

export async function importLocalXWear(file) {
  if (!/\.xwear$/i.test(file.name)) throw new Error('Choose a .xwear outfit exported from VRoid Studio')
  if (file.size > 64 * 1024 ** 2) throw new Error('XWear files must be smaller than 64 MiB')
  const bytes = await file.arrayBuffer()
  const signature = new Uint8Array(bytes, 0, Math.min(4, bytes.byteLength))
  if (signature[0] !== 0x50 || signature[1] !== 0x4b) throw new Error('This file is not an XWear archive')
  const hash = [...new Uint8Array(await crypto.subtle.digest('SHA-256', bytes))].map((n) => n.toString(16).padStart(2, '0')).join('')
  const definition = { id: `local-${hash}`, name: file.name.replace(/\.xwear$/i, ''), format: 'xwear', url: `xwear-local:${hash}`, local: true }
  // Reuse a prepared fit/coverage profile only for the exact same source bytes.
  // A new or edited outfit needs its own authored coverage settings.
  const catalog = await fetch('/models.json').then((r) => r.json()).catch(() => ({}))
  const profile = catalog.outfits?.find((o) => o.sourceSha256 === hash)
  if (profile?.bodyCoverage) definition.bodyCoverage = profile.bodyCoverage
  if (profile?.fitPolicy) {
    definition.fitPolicy = profile.fitPolicy
    definition.fits = profile.fits || []
    definition.sourceSha256 = hash
  }
  // Persist owned bytes rather than a Blob handle, which can become unreadable
  // after a browser restart when its backing temporary file is reclaimed.
  await operation('readwrite', (store) => store.put({ id: hash, definition, bytes }))
  return definition
}

export async function localXWearCatalog() {
  return (await operation('readonly', (store) => store.getAll())).map((entry) => entry.definition)
}

export async function readLocalXWear(url) {
  const entry = await operation('readonly', (store) => store.get(url.slice('xwear-local:'.length)))
  if (!entry) throw new Error('This local outfit is missing. Import the .xwear file again.')
  return entry.bytes || entry.blob.arrayBuffer()
}
